// eslint-disable-next-line @typescript-eslint/naming-convention
export const Placement = {
    Top: "top",
    Left: "left",
    Right: "right",
    Bottom: "bottom",
} as const;

export type PlacementType = (typeof Placement)[keyof typeof Placement];
